import { $location, getQueryString } from '@umu/umu-dom';
import { isRegisterUser } from '../../../services/accountService';
import { isInUse } from '@umu/umu-util';
import { isMobile } from '@umu/umu-ua';
import { isFromCourseMiniApp } from '../../../@utils';

const getMockData = () => {
    return [
        {
            type: 'invite_to_join_enterprise_show',
            data: {
                enterprise_logo: 'https://qajenkins.umu.work/static/69d5229a/images/48x48/notepad.png',
                enterprise_name: '企业名称test',
            },
        },
        {
            type: 'enterprise_expire',
            data: [
                {
                    left_day: 2,
                    version_type: '9',
                    expire_date: '2023-04-01',
                },
            ],
        },
        {
            type: 'daily_login',
            data: [
                {
                    active_days: 22,
                    growth_points: '30',
                },
            ],
        },
        {
            type: 'user_level',
            data: [
                {
                    user_level: 3,
                },
            ],
        },
        {
            type: 'user_level',
            data: [
                {
                    user_level: 11,
                },
            ],
        },
        {
            type: 'user_level',
            data: [
                {
                    user_level: 16,
                },
            ],
        },
        {
            type: 'user_level',
            data: [
                {
                    user_level: 21,
                },
            ],
        },
        {
            type: 'user_level',
            data: [
                {
                    user_level: 27,
                },
            ],
        },
        {
            type: 'user_level',
            data: [
                {
                    user_level: 999,
                },
            ],
        },
        {
            type: 'user_medal',
            data: [
                {
                    id: '25',
                    medal_title: '成长之路',
                    medal_remark: '升级至LV.11',
                    growth_points: 100,
                    action_num: 11,
                    action_name: '获赞',
                    medal_type: '100',
                    medal_rank: '1',
                },
            ],
        },
        {
            type: 'user_level_privilege_offline',
            data: {
                offline_date: '2022-12-31',
            },
        },
    ];
};
// 根据URL参数以及路径筛选是否进行弹窗操作
const getIsProhibitShowPopup = (eid?: string) => {
    const localPath = $location.pathname;
    const urls = $location.href;
    const isHidePopups = getQueryString('isHidePopUps') || '';
    if (!!Number(isHidePopups) || !!isFromCourseMiniApp()) {
        return true;
    }

    if (isInUse()) {
        return true;
    }

    const iframeFrom = getQueryString('iframeFrom') || '';
    // iframe嵌套页面来源为以下不进行弹窗
    const banPopupIframeList = ['popupDialog', 'pcCourse', 'prohibitDialog'];
    const isBanPopupIframe = banPopupIframeList.indexOf(iframeFrom) !== -1;
    // 本地路径为以下不进行弹窗
    const banLocalPathList = [
        '/use',
        '/platformManage/',
        '/auth/login',
        '/popup-pages/',
        '/screenshot/',
        '/session/live/',
        '/node-micro/',
        '/session/articleEdit',
    ];
    const banLocalPath = banLocalPathList.filter((_) => {
        return localPath.indexOf(_) !== -1;
    });
    // URL参数为以下不进行弹窗
    const banUrlList = ['referer=daily_login'];
    const banUrl = banUrlList.filter((_) => {
        return urls.indexOf(_) !== -1;
    });
    // 登录token不为空且非移动端不进行弹窗
    const loginToken = getQueryString('login_token') || '';
    if (loginToken !== '' && !isMobile) {
        return true;
    }
    // 未注册用户且eid为空不进行弹窗
    if (!isRegisterUser() && eid === '') {
        return true;
    }
    return isBanPopupIframe || !!banLocalPath.length || !!banUrl.length;
};
export { getMockData, getIsProhibitShowPopup };
